// removed by extract-text-webpack-plugin
module.exports = {"container":"_2gaIj"};


//////////////////
// WEBPACK FOOTER
// ./app/components/text-editor/text-editor-link.scss
// module id = 795
// module chunks = 3 4 5 6 7